const getCarouselSettings = ({
  enableTwoRowDisplay,
  theme,
  width
}) => {
  const isLargeBreakpoint = width >= theme.breakpoints.values.lg;
  const isMediumBreakpoint = width >= theme.breakpoints.values.md && width < theme.breakpoints.values.lg;
  const columns = isLargeBreakpoint ? 5 : isMediumBreakpoint ? 4 : 3;
  const itemsPerSlide = enableTwoRowDisplay ? 1 : columns;
  const itemsTwoRowMax = columns * 2;
  let navigationButtonTopOffset;
  if (enableTwoRowDisplay) {
    navigationButtonTopOffset = "auto";
  } else {
    if (isLargeBreakpoint) {
      navigationButtonTopOffset = "55px";
    } else if (isMediumBreakpoint) {
      navigationButtonTopOffset = "45px";
    } else {
      navigationButtonTopOffset = "20px";
    }
  }
  return {
    columns,
    itemsPerSlide,
    itemsTwoRowMax,
    navigationButtonTopOffset
  };
};
export {
  getCarouselSettings
};
